import HomeView from "../presentation/views/HomeView.vue";
/**
 * Home Module Routes and Navigation
 *
 * Owns the application root path. The shell no longer redirects "/" to
 * "/profile/notifications" — authenticated users land on the home page.
 */
export const homeRoutes = [
    {
        path: "/",
        name: "Home",
        component: HomeView,
        // Reuses the heading the page renders — no second Tolgee key for the same words.
        meta: { requiresAuth: true, titleKey: "home.dashboard.title" },
    },
];
export const homeNavigationItems = [];
